export default {
  init() {
    // JavaScript to be fired on the blog posts page
  },
  finalize() {
    if($('.featured-slider')[0]){
      $('.featured-slider').slick({
        dots: true,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  },
};
